import type { ImportIssue } from '../api/types'

export function updateMonthMask(current: number, monthIndex: number, selected: boolean): number {
  if (!Number.isInteger(monthIndex) || monthIndex < 0 || monthIndex >= 12) throw new Error('Некорректный номер месяца')
  const bit = 1 << monthIndex
  return selected ? current | bit : current & ~bit
}

export function initialMonthMask(issue: ImportIssue): number {
  for (const candidate of [issue.normalizedValue, issue.suggestedValue]) {
    const value = typeof candidate === 'number' ? candidate : typeof candidate === 'string' && /^\d+$/.test(candidate) ? Number(candidate) : NaN
    if (Number.isInteger(value) && value >= 1 && value <= 4095) return value
  }
  return 0
}
